import api from "../index";
import { apiUrl } from "../../utils/constants";
import { GetAuthUserLocalStorage } from "../localStorage/localStorage";

export const CheckFileUploadStorageAvailable = (params) =>
  api.get(
    `${apiUrl.salon_check_storage_available}/${
      GetAuthUserLocalStorage()?.salon?.id
    }`,
    { params },
  );

export const UpdateFileUploadStorageSizeAvailability = (size) =>
  api.post(
    `${apiUrl.salon_check_storage_available}/${
      GetAuthUserLocalStorage()?.salon.id
    }?size=${size}`,
  );

export const GetCategoryTags = (params) =>
  api.get(`${apiUrl.categoryTags}`, { params });

export const GetSalonByID = (id) => api.get(`${apiUrl.salon}/${id}`);

export const DeleteSalonByID = (id) => api.delete(`${apiUrl.salon}/${id}`);

export const GetAllSalons = (params) => api.get(`${apiUrl.salon}`, { params });

/**
 * Lightweight variant of GetAllSalons for dropdown/selector usage.
 *
 * Backend returns only {id, name, image, slug, city, status, directory_name,
 * user_id, uniid, country_id} — no relations, no withCount. Use this anywhere
 * the UI only renders salon name/id (headers, layout selectors). The full
 * GetAllSalons still works and is used by OrganizationPage which renders
 * product_line, meta.members, etc.
 */
export const GetAllSalonsLight = (params) =>
  api.get(`${apiUrl.salon}`, { params: { ...(params || {}), light: 1 } });

export const GetSalonSegments = (params) =>
  api.get(`${apiUrl.salonSegments}`, { params });

export const UpdateSalon = (id, payload) =>
  api.put(`${apiUrl.salon}/${id}`, payload);

export const CheckTitle = (params) =>
  api.get(`${apiUrl.checkTitle}`, { params });
